<template>
    <div class="step">
        <div class="title"><span>Шаг 2</span> Быстрая регистрация в сервисе</div>  
        <div class="second-step">
            <div class="block-phone">
                <p>Укажите свой номер телефона, мы отправим вам сообщение с кодом подтверждения</p>
                <div class="block-item-phone">
                    <div class="item">
                        <vue-tel-input v-model="currentPhone.number" default-country="ru" @validate="enterPhone" v-bind="phoneInputProps"></vue-tel-input>
                    </div>
                    <div class="item">
                        <button @click="sendSmsCode" :disabled="checkSendSmsCodeButtonDisabled()">Отправить код</button>
                        <div class="timer" v-if="sendSmsStep && repeatTime">Отправить код повторно можно через {{ repeatTimeString }}</div>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <SmsCodeInput 
                @sendCode="enterSmsCode" 
                v-if="sendSmsStep" 
                :phone="currentPhone.number"
                :error="error"
                ></SmsCodeInput>
            </transition>
        </div>
        <button class="gosuslugi" v-if="gosuslugi">Войти через Госуслуги</button>
        <p class="privacy">Нажимая «Отправить код», вы принимаете «<a target="_blank" :href="privacyLink">Условия использования сервиса</a>» и даете «<a target="_blank" :href="personalData">Согласие на обработку персональных данных</a>»</p>
    </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import SmsCodeInput from '../SmsCodeInput/SmsCodeInput.vue'

import { bus } from '../../main'

import './step2.scss'

const allCountries = [
    {
        name: 'Австралия',
        iso2: 'AU',
        dialCode: '61'
    },
    {
        name: 'Австрия',
        iso2: 'AT',
        dialCode: '43'
    },
    {
        name: 'Азербайджан',
        iso2: 'AZ',
        dialCode: '994'
    },
    {
        name: 'Алжир',
        iso2: 'DZ',
        dialCode: '213'
    },
    {
        name: 'Ангола',
        iso2: 'AO',
        dialCode: '244'
    },
    {
        name: 'Аргентина',
        iso2: 'AR',
        dialCode: '54'
    },
    {
        name: 'Армения',
        iso2: 'AM',
        dialCode: '374'
    },
    {
        name: 'Бангладеш',
        iso2: 'BD',
        dialCode: '880'
    },
    {
        name: 'Беларусь',
        iso2: 'BY',
        dialCode: '375'
    },
    {
        name: 'Бельгия',
        iso2: 'BE',
        dialCode: '32'
    },
    {
        name: 'Бенин',
        iso2: 'BJ',
        dialCode: '229'
    },
    {
        name: 'Болгария',
        iso2: 'BG',
        dialCode: '359'
    },
    {
        name: 'Боливия',
        iso2: 'BO',
        dialCode: '591'
    },
    {
        name: 'Босния и Герцеговина',
        iso2: 'BA',
        dialCode: '387'
    },
    {
        name: 'Бразилия',
        iso2: 'BR',
        dialCode: '55'
    },
    {
        name: 'Буркина-Фасо',
        iso2: 'BF',
        dialCode: '226'
    },
    {
        name: 'Великобритания',
        iso2: 'GB',
        dialCode: '44'
    },
    {
        name: 'Венгрия',
        iso2: 'HU',
        dialCode: '36'
    },
    {
        name: 'Венесуэла',
        iso2: 'VE',
        dialCode: '58'
    },
    {
        name: 'Вьетнам',
        iso2: 'VN',
        dialCode: '84'
    },
    {
        name: 'Гаити',
        iso2: 'HT',
        dialCode: '509'
    },
    {
        name: 'Гана',
        iso2: 'GH',
        dialCode: '233'
    },
    {
        name: 'Гватемала',
        iso2: 'GT',
        dialCode: '502'
    },
    {
        name: 'Гвинея',
        iso2: 'GN',
        dialCode: '224'
    },
    {
        name: 'Германия',
        iso2: 'DE',
        dialCode: '49'
    },
    {
        name: 'Гондурас',
        iso2: 'HN',
        dialCode: '504'
    },
    {
        name: 'Греция',
        iso2: 'GR',
        dialCode: '30'
    },
    {
        name: 'Грузия',
        iso2: 'GE',
        dialCode: '995'
    },
    {
        name: 'Доминиканская Республика',
        iso2: 'DO',
        dialCode: '0'
    },
    {
        name: 'Египет',
        iso2: 'EG',
        dialCode: '20'
    },
    {
        name: 'Замбия',
        iso2: 'ZM',
        dialCode: '260'
    },
    {
        name: 'Зимбабве',
        iso2: 'ZW',
        dialCode: '263'
    },
    {
        name: 'Израиль',
        iso2: 'IL',
        dialCode: '972'
    },
    {
        name: 'Индия',
        iso2: 'IN',
        dialCode: '91'
    },
    {
        name: 'Индонезия',
        iso2: 'ID',
        dialCode: '62'
    },
    {
        name: 'Иордания',
        iso2: 'JO',
        dialCode: '962'
    },
    {
        name: 'Ирак',
        iso2: 'IQ',
        dialCode: '964'
    },
    {
        name: 'Иран',
        iso2: 'IR',
        dialCode: '98'
    },
    {
        name: 'Ирландия',
        iso2: 'IE',
        dialCode: '353'
    },
    {
        name: 'Испания',
        iso2: 'ES',
        dialCode: '34'
    },
    {
        name: 'Италия',
        iso2: 'IT',
        dialCode: '39'
    },
    {
        name: 'Йемен',
        iso2: 'YE',
        dialCode: '967'
    },
    {
        name: 'Казахстан',
        iso2: 'KZ',
        dialCode: '7'
    },
    {
        name: 'Камбоджа',
        iso2: 'KH',
        dialCode: '855'
    },
    {
        name: 'Камерун',
        iso2: 'CM',
        dialCode: '237'
    },
    {
        name: 'Канада',
        iso2: 'CA',
        dialCode: '1'
    },
    {
        name: 'Кения',
        iso2: 'KE',
        dialCode: '254'
    },
    {
        name: 'Киргизия',
        iso2: 'KG',
        dialCode: '996'
    },
    {
        name: 'Китай',
        iso2: 'CN',
        dialCode: '86'
    },
    {
        name: 'Колумбия',
        iso2: 'CO',
        dialCode: '57'
    },
    {
        name: 'Конго',
        iso2: 'CG',
        dialCode: '242'
    },
    {
        name: 'Куба',
        iso2: 'CU',
        dialCode: '53'
    },
    {
        name: 'Лаос',
        iso2: 'LA',
        dialCode: '856'
    },
    {
        name: 'Латвия ',
        iso2: 'LV',
        dialCode: '371'
    },
    {
        name: 'Ливия',
        iso2: 'LY',
        dialCode: '218'
    },
    {
        name: 'Литва',
        iso2: 'LT',
        dialCode: '370'
    },
    {
        name: 'Мавритания ',
        iso2: 'MR',
        dialCode: '222'
    },
    {
        name: 'Мадагаскар ',
        iso2: 'MG',
        dialCode: '261'
    },
    {
        name: 'Македония',
        iso2: 'MK',
        dialCode: '389'
    },
    {
        name: 'Малави ',
        iso2: 'MW',
        dialCode: '265'
    },
    {
        name: 'Малайзия ',
        iso2: 'MY',
        dialCode: '60'
    },
    {
        name: 'Мали',
        iso2: 'ML',
        dialCode: '223'
    },
    {
        name: 'Марокко ',
        iso2: 'MA',
        dialCode: '212'
    },
    {
        name: 'Мексика ',
        iso2: 'MX',
        dialCode: '52'
    },
    {
        name: 'Мозамбик ',
        iso2: 'MZ',
        dialCode: '258'
    },
    {
        name: 'Молдова',
        iso2: 'MD',
        dialCode: '373'
    },
    {
        name: 'Монголия ',
        iso2: 'MN',
        dialCode: '976'
    },
    {
        name: 'Непал',
        iso2: 'NP',
        dialCode: '977'
    },
    {
        name: 'Нигер',
        iso2: 'NE',
        dialCode: '227'
    },
    {
        name: 'Нигерия ',
        iso2: 'NG',
        dialCode: '234'
    },
    {
        name: 'Нидерланды ',
        iso2: 'NL',
        dialCode: '31'
    },
    {
        name: 'Никарагуа ',
        iso2: 'NI',
        dialCode: '505'
    },
    {
        name: 'Новая Зеландия ',
        iso2: 'NZ',
        dialCode: '64'
    },
    {
        name: 'Норвегия',
        iso2: 'NO',
        dialCode: '47'
    },
    {
        name: 'Объединенные Арабские Эмираты',
        iso2: 'AE',
        dialCode: '971'
    },
    {
        name: 'Пакистан',
        iso2: 'PK',
        dialCode: '92'
    },
    {
        name: 'Парагвай',
        iso2: 'PY',
        dialCode: '595'
    },
    {
        name: 'Перу',
        iso2: 'PE',
        dialCode: '51'
    },
    {
        name: 'Польша',
        iso2: 'PL',
        dialCode: '48'
    },
    {
        name: 'Португалия',
        iso2: 'PT',
        dialCode: '351'
    },
    {
        name: 'Россия',
        iso2: 'RU',
        dialCode: '7'
    },
    {
        name: 'Румыния',
        iso2: 'RO',
        dialCode: '40'
    },
    {
        name: 'Саудовская Аравия',
        iso2: 'SA',
        dialCode: '966'
    },
    {
        name: 'Северная Корея',
        iso2: 'KP',
        dialCode: '850'
    },
    {
        name: 'Сенегал',
        iso2: 'SN',
        dialCode: '221'
    },
    {
        name: 'Сербия',
        iso2: 'RS',
        dialCode: '381'
    },
    {
        name: 'Сингапур',
        iso2: 'SG',
        dialCode: '65'
    },
    {
        name: 'Сирия',
        iso2: 'SY',
        dialCode: '963'
    },
    {
        name: 'Соединенные Штаты Америки',
        iso2: 'US',
        dialCode: '1'
    },
    {
        name: 'Сомали',
        iso2: 'SO',
        dialCode: '252'
    },
    {
        name: 'Судан',
        iso2: 'SD',
        dialCode: '249'
    },
    {
        name: 'Таджикистан',
        iso2: 'TJ',
        dialCode: '992'
    },
    {
        name: 'Таиланд',
        iso2: 'TH',
        dialCode: '66'
    },
    {
        name: 'Тайвань',
        iso2: 'TW',
        dialCode: '886'
    },
    {
        name: 'Танзания',
        iso2: 'TZ',
        dialCode: '255'
    },
    {
        name: 'Тунис',
        iso2: 'TN',
        dialCode: '216'
    },
    {
        name: 'Турция',
        iso2: 'TR',
        dialCode: '90'
    },
    {
        name: 'Уганда',
        iso2: 'UG',
        dialCode: '256'
    },
    {
        name: 'Узбекистан',
        iso2: 'UZ',
        dialCode: '998'
    },
    {
        name: 'Украина',
        iso2: 'UA',
        dialCode: '380'
    },
    {
        name: 'Уругвай',
        iso2: 'UY',
        dialCode: '598'
    },
    {
        name: 'Филиппины',
        iso2: 'PH',
        dialCode: '63'
    },
    {
        name: 'Финляндия',
        iso2: 'FI',
        dialCode: '358'
    },
    {
        name: 'Хорватия',
        iso2: 'HR',
        dialCode: '385'
    },
    {
        name: 'Чад',
        iso2: 'TD',
        dialCode: '235'
    },
    {
        name: 'Чешская республика',
        iso2: 'CZ',
        dialCode: '420'
    },
    {
        name: 'Чили',
        iso2: 'CL',
        dialCode: '56'
    },
    {
        name: 'Швейцария',
        iso2: 'CH',
        dialCode: '41'
    },
    {
        name: 'Швеция',
        iso2: 'SE',
        dialCode: '46'
    },
    {
        name: 'Шри Ланка',
        iso2: 'LK',
        dialCode: '94'
    },
    {
        name: 'Эквадор',
        iso2: 'EC',
        dialCode: '593'
    },
    {
        name: 'Эфиопия',
        iso2: 'ET',
        dialCode: '251'
    },
    {
        name: 'ЮАР',
        iso2: 'ZA',
        dialCode: '27'
    },
    {
        name: 'Южная Корея',
        iso2: 'KR',
        dialCode: '82'
    },
    {
        name: 'Ямайка',
        iso2: 'JM',
        dialCode: '877'
    },
    {
        name: 'Япония',
        iso2: 'JP',
        dialCode: '81'
    },
    {
        name: 'Афганистан',
        iso2: 'AF',
        dialCode: '93'
    },
    {
        name: 'Туркменистан',
        iso2: 'TM',
        dialCode: '993'
    },
];

const countryIdByIso = {
    'AU': 3,
    'AT': 4,
    'AZ': 5,
    'DZ': 6,
    'AO': 8,
    'AR': 9,
    'AM': 10,
    'BD': 11,
    'BY': 12,
    'BE': 13,
    'BJ': 14,
    'BG': 15,
    'BO': 16,
    'BA': 17,
    'BR': 18,
    'BF': 19,
    'GB': 20,
    'HU': 21,
    'VE': 22,
    'VN': 23,
    'HT': 24,
    'GH': 25,
    'GT': 26,
    'GN': 27,
    'DE': 28,
    'HN': 29,
    'GR': 30,
    'GE': 31,
    'DO': 32,
    'EG': 33,
    'ZM': 34,
    'ZW': 35,
    'IL': 36,
    'IN': 37,
    'ID': 39,
    'JO': 40,
    'IQ': 41,
    'IR': 42,
    'IE': 43,
    'ES': 44,
    'IT': 45,
    'YE': 46,
    'KZ': 47,
    'KH': 48,
    'CM': 49,
    'CA': 50,
    'KE': 51,
    'KG': 52,
    'CN': 53,
    'CO': 54,
    'CG': 55,
    'CU': 56,
    'LA': 57,
    'LV': 58,
    'LY': 59,
    'LT': 60,
    'MR': 61,
    'MG': 62,
    'MK': 63,
    'MW': 64,
    'MY': 65,
    'ML': 66,
    'MA': 67,
    'MX': 68,
    'MZ': 69,
    'MD': 70,
    'MN': 71,
    'NP': 72,
    'NE': 73,
    'NG': 74,
    'NL': 75,
    'NI': 76,
    'NZ': 77,
    'NO': 78,
    'AE': 79,
    'PK': 80,
    'PY': 81,
    'PE': 82,
    'PL': 83,
    'PT': 84,
    'RU': 85,
    'RO': 86,
    'SA': 87,
    'KP': 88,
    'SN': 89,
    'RS': 90,
    'SG': 91,
    'SY': 92,
    'US': 93,
    'SO': 94,
    'SD': 95,
    'TJ': 96,
    'TH': 97,
    'TW': 98,
    'TZ': 99,
    'TN': 100,
    'TR': 101,
    'UG': 102,
    'UZ': 103,
    'UA': 104,
    'UY': 105,
    'PH': 106,
    'FI': 107,
    'HR': 108,
    'TD': 109,
    'CZ': 110,
    'CL': 111,
    'CH': 112,
    'SE': 113,
    'LK': 114,
    'EC': 115,
    'ET': 116,
    'ZA': 117,
    'KR': 118,
    'JM': 119,
    'JP': 120,
    'AF': 121,
    'TM': 122,
    'AB': 123,
};

export default {
  name: 'Step2',
  props: ['user'],
  data(){
    return {
      sendPhoneNumber: false,
      sendSmsStep: false,
      smsCodeResult: null,
      sendPhoneButtonDisabled: false,
      gosuslugi: false,
      repeatTime: 0,
      repeatInterval: null,
      repeatTimeString: '',
      error: {
        exist: false,
        message: '',
      },
      currentPhone: {
        number: null,
        valid: false,
        countryCode: null
      },
      phoneInputProps: {
        allCountries: allCountries,
        mode: 'international',
        preferredCountries: ['RU'],
        autoDefaultCountry: true,
        validCharactersOnly: true,
        dropdownOptions: {
          showDialCodeInList: true,
          showDialCodeInSelection: true,
          showFlags: true,
          showCountryName: true
        },
        autoFormat: true,
        inputOptions: {
          placeholder: 'Ваш телефон',
        },
      }
    }
  },
  methods: {
    checkSendSmsCodeButtonDisabled() {
        return !(this.currentPhone && this.currentPhone.valid && !this.sendPhoneNumber && !this.repeatTime);
    },
    enterPhone(phoneObject) {
        this.currentPhone.valid = phoneObject.valid;
        this.currentPhone.number = phoneObject.number;
        this.currentPhone.countryCode = phoneObject.countryCode;
    },
    sendSmsCode() {
        const self = this;

        if (this.sendPhoneNumber) {
            return
        }

        this.sendPhoneNumber = true;

        const formData = new FormData();
        formData.append('phone', this.currentPhone.number);

        let url = process.env.VUE_APP_HOST + '/mobile/send_sms_code/';
        fetch(url, {
            method: 'POST',
            body: formData
        }).then((response) => {
            response.json().then(function(data) {
                if (data.status === 'OK') {
                    self.sendSmsStep = true;
                    self.setRepeatTime(data.timeout);
                    self.sendPhoneNumber = false;

                    bus.$emit('laboratoryLanding.analytics', {action: 'enterPhoneNumber'})
                } else {
                    self.sendPhoneNumber = false;
                }
            })
        }, (response) => {
            console.error('Возникла неизвестная ошибка', response);
            self.error.exist = true;
            self.error.message = 'Возникла неизвестная ошибка';
        })
    },
    setRepeatTime(time) {
      const self = this;
      this.setRepeatTimeValue(time);

      if (this.repeatInterval) {
          clearInterval(this.repeatInterval)
      }

      this.repeatInterval = setInterval(function() {
          let time = self.repeatTime - 1;
          self.setRepeatTimeValue(time)
      }, 1000)
    },
    setRepeatTimeValue(time) {
      this.repeatTime = time;
      if (this.repeatTime) {
        this.repeatTimeString = ((this.repeatTime / 60) >> 0) + ':' + (this.repeatTime % 60 >= 10 ? this.repeatTime % 60 : ('0' + this.repeatTime % 60));
      } else {
        clearInterval(this.repeatInterval);
        this.repeatTimeString = '';
      }
    },
    enterSmsCode(data) {
      const self = this;

      const countryId = countryIdByIso[this.currentPhone.countryCode];

      const formData = new FormData();
      formData.append('phone', this.currentPhone.number);
      formData.append('country_id', countryId);
      formData.append('code', data.code);
      formData.append('with_auth_token', 'true');

      bus.$emit('laboratoryLanding.analytics', {action: 'enterSmsCode'});

      let url = process.env.VUE_APP_HOST + '/mobile/phone_login/';
      fetch(url, {
          method: 'POST',
          body: formData
      }).then((response) => {
          response.json().then(function(data) {
              if (data.status === 'OK') {
                 self.user.session = data.session_id;
                 self.user.authToken = data.auth_token;

                 bus.$emit('laboratoryLanding.analytics', {
                   action: 'auth',
                   userId: data.user_id
                 });

                 self.$emit('complete')
              } else {
                  console.error(data);
                  self.error.exist = true;
                  self.error.message = data.message;
              }
          })
      }, (response) => {
          console.error('Возникла неизвестная ошибка', response);
          self.error.exist = true;
          self.error.message = 'Возникла неизвестная ошибка';
      });
    }
  },
  computed: {
      privacyLink: function () {
          return process.env.VUE_APP_HOST + '/privacy/'
      },
      personalData: function () {
          return process.env.VUE_APP_HOST + '/privacy/contract2/';
      }
  },
  watch: {
    'currentPhone.valid'() {
      this.sendPhoneButtonDisabled = this.currentPhone.valid
    }
  },
  components: {
    VueTelInput,
    SmsCodeInput
  }
}
</script>

<style src="vue-tel-input/dist/vue-tel-input.css"></style>